import { type FAQ } from "../../../../Components/FAQ/FAQAccordion";

export const fsk8sFaqs: FAQ[] = [
  {
    question: "What is Flexsave for Kubernetes?",
    answer: "Flexsave for Kubernetes is a solution that helps manage and optimize Kubernetes resources.",
  },
  {
    question: "How do I install the agent",
    answer: "To install the agent, follow the instructions provided in the documentation.",
  },
  {
    question: "What permissions are required to start using this feature",
    answer: "You will need appropriate permissions to access and manage Kubernetes resources.",
  },
  {
    question: "How can Flexsave for Kubernetes benefit me?",
    answer: "Flexsave for Kubernetes can help improve resource utilization and reduce costs.",
  },
];
